module.exports = __webpack_public_path__ + "img/032d5989f84c46f6d006e676922cada3.9ca82a38.png";